export default "__VITE_ASSET__d2180eba__"